let language = {
    PURCHASE_QUANTITY_MODAL_QTY_MOQ_TIP: "最小起订量为{{productMoq}}。",
    PURCHASE_QUANTITY_MODAL_QTY_MAXLIMIT_TIP:"最大订购数量为{{maxLimit}}。",
    PURCHASE_QUANTITY_MODAL_OK_BTN:"确定",
    PURCHASE_QUANTITY_MODAL_CANCEL_BTN:"取消"
}

export { language }